import { LoadingButton } from '@mui/lab';
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Skeleton, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { useAuthContext } from 'src/auth/useAuthContext';
import Container from 'src/components/container/Container';
import CustomInput from 'src/components/customerinput/CustomerInput';
import { notify } from 'src/components/notify';
import PageStructure from 'src/components/PageStructure';
import { useSettingsContext } from 'src/components/settings';
import createCleanEntry from 'src/services/clear-entry/createEntry';
import getDiscountEventsDetailsData from 'src/services/discount/getDiscountPopDeatails';
import getEventsStrikePackages from 'src/services/eventLabel/geteventPackages';

export default function HandleEntry() {
    const { themeStretch } = useSettingsContext();
    const location = useLocation()
    const editData = location.state
    const { user } = useAuthContext()
    const [value, setValue] = useState(2);
    const [search, setSearch] = useState("")
    const [status, setStatus] = useState("active")
    const [loading, setLoading] = useState(false)
    const [events, setEvents] = useState([])
    const [selectEvent, setSelectEvent] = useState("")
    const [runAt, setRunAt] = useState("")
    const [selectPackages, setSelectPackages] = useState([])
    const [packageOptions, setPackageOptions] = useState([])

    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const data = await getDiscountEventsDetailsData(user, value, search, 0, 15);
            setEvents(data?._payload);
            setLoading(false)
        }

        fetchData()
    }, [value])

    useEffect(() => {
        const fetchData = async () => {
            const handle = events.find((it) => it._id == selectEvent)
            if (handle) {
                const response = await getEventsStrikePackages(user, handle.handle)
                setPackageOptions(response[0].package_data || [])
            }
        }
        if (selectEvent) {
            fetchData()
        }
    }, [selectEvent])

    const handleChange2 = (event) => {
        setSelectPackages(event.target.value);
    };
    const [loading2, setLoading2] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!selectEvent) {
                return notify("Event is required.")
            }
            if (!selectPackages.length) {
                return notify("Package is required.")
            }
            if (runAt == undefined || runAt == "" || runAt == null) {
                return notify("Run at is required.")
            }
            if (parseFloat(runAt) < 0 || parseFloat(runAt) > 23) {
                notify("Run At must be between 0 and 23.");
                return;
            }

            const payload = {
                event_id: selectEvent,
                package_ids: selectPackages,
                run_at: runAt,
                status: status,
            };
            setLoading2(true)
            const response = await createCleanEntry(user, payload)
            if (response) {
                notify("Schedule Successfully.", "success")
                navigate(-1)
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoading2(false)
        }
    };

    useEffect(() => {
        if (editData && events.length) {
            console.log(editData, "editData");

            const { package_ids, event_id, run_at, status } = editData
            setStatus(status)
            setValue(editData.event.event_status)
            setSelectEvent(event_id)
            setSelectPackages(package_ids)
            setRunAt(run_at)
        }
    }, [editData, packageOptions, events, location.state])
    console.log(selectPackages, "selectPackages");


    return (
        <div>
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <PageStructure title={editData ? "Update Entry Reset" : "Create Entry Reset"}>
                    <form onSubmit={handleSubmit}>
                        <Stack maxWidth={600}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} >
                                    <CustomInput
                                        label="Select Event"
                                        required
                                        input={
                                            <Box sx={{ border: 1, borderColor: "divider", padding: "10px", borderRadius: "10px" }}>
                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                    <Tabs variant="fullWidth" value={value} onChange={handleChange}>
                                                        <Tab label="Live Event" value={2} />
                                                        <Tab label="Upcoming Event" value={1} />
                                                    </Tabs>
                                                </Box>
                                                <Paper mt={2} sx={{ maxHeight: "300px", overflowX: "auto", padding: "0px 10px", scrollbarWidth: "none", border: 1, borderColor: "divider" }}>
                                                    {
                                                        loading ? <Stack gap={2} sx={{ padding: "15px 0" }}>
                                                            {Array.from({ length: 8 }).map((_, i) => (
                                                                <Skeleton key={i} variant="rounded" width={"100%"} height={15} />
                                                            ))}
                                                        </Stack> :

                                                            events?.length > 0 ? <FormControl>
                                                                <RadioGroup
                                                                    onChange={(e) => setSelectEvent(e.target.value)}
                                                                    required
                                                                    value={selectEvent}
                                                                >
                                                                    {events?.map((it) => (
                                                                        <FormControlLabel key={it._id} value={it._id} control={<Radio />} label={it.name} />
                                                                    ))}
                                                                </RadioGroup>
                                                            </FormControl> : <Box sx={{ padding: "10px" }}>
                                                                No Event Found...
                                                            </Box>
                                                    }
                                                </Paper>
                                            </Box>
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} >
                                    <CustomInput
                                        label="Select Packages"
                                        required
                                        input={
                                            <Select
                                                multiple
                                                required
                                                disabled={!selectEvent}
                                                fullWidth
                                                value={selectPackages}
                                                onChange={handleChange2}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (selected.length === 0) {
                                                        return <span style={{ color: "#9e9e9e" }}>--Select Package--</span>;
                                                    }
                                                    return packageOptions
                                                        .filter((pkg) => selected.includes(pkg.package._id))
                                                        .map((pkg) => pkg.package_name)
                                                        .join(", ");
                                                }}
                                            >
                                                <MenuItem value="" disabled>
                                                    --Select Package--
                                                </MenuItem>
                                                {packageOptions.map((pkg) => (
                                                    <MenuItem key={pkg._id} value={pkg.package._id}>
                                                        <Checkbox checked={selectPackages.indexOf(pkg.package._id) > -1} />
                                                        <ListItemText primary={pkg.package_name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} >
                                    <CustomInput
                                        required
                                        label="Run At"
                                        input={
                                            <TextField
                                                placeholder='Enter Run at...'
                                                onChange={(e) => setRunAt(e.target.value)}
                                                required
                                                value={runAt}
                                                type='number'
                                                onWheel={(e) => e.target.blur()}
                                                fullWidth
                                                inputProps={{ min: 0, max: 23 }}
                                            />
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} >
                                    <CustomInput
                                        label="Status"
                                        input={
                                            <RadioGroup
                                                onChange={(e) => setStatus(e.target.value)}
                                                value={status}
                                            >
                                                <FormControlLabel control={<Radio />} value="active" label="Active" />
                                                <FormControlLabel control={<Radio />} value="inactive" label="In Active" />
                                            </RadioGroup>
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Stack direction="row" gap={1} justifyContent="flex-start">
                                        <LoadingButton loading={loading2} disabled={loading2} type="submit" variant="contained" fullWidth>
                                            {editData ? "Update" : "Submit"}
                                        </LoadingButton>
                                        <Button type="button" variant="outlined" onClick={() => navigate(-1)} fullWidth>
                                            Cancel
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                    </form>
                </PageStructure>
            </Container>
        </div>
    )
}
